import React from "react";
import Header from "../Header";
import BaseContainerDividingLineRHSSidebar from "../BaseContainerDividingLineRHSSidebar";
import './EndOfLifePage.css';


const EndOfLifePage = (props) => {
    const { maxValue } = props;

    return(
        <div className="container-center-horizontal">
            <div className="eol-home-page screen">
                <div className="flex-col-eol">
                    <Header />
                    <div className="eol-container">
                        <BaseContainerDividingLineRHSSidebar />
                        <label className="max-value-response">{maxValue}</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndOfLifePage;